import React, { use } from 'react';

//import Scss
import './assets/scss/themes.scss';

//imoprt Route
import Route from './Routes';
import './App.css';

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend 
import fakeBackend from "./helpers/AuthType/fakeBackend";
import "./utils/arrayPrototypes";



// Activating fake backend
fakeBackend();
import { Toaster } from 'react-hot-toast';
import TenantStylesLoader from './Layouts/TenantStylesLoader';
import WebSocketBillPrinter from './QRCodeAdminPage/POS/component/WebSocketBillPrinter';

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  // //check for 1st time page url load and check for token validation via server:
  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   if (token) {
  //     dispatch(checkToken(token));
  //   }  
  // }, []); 
  // function checkToken(token) {
  //   return async (dispatch) => {
  //     try {
  //       const response = await _BaseAPIService.sendRequest({
  //         method: "GET",
  //         url: "/auth/check-token",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       });
  //       if (response.status === 200) {
  //         dispatch(setToken(token));
  //       }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };
  // }
  return (
    <React.Fragment>
      <TenantStylesLoader/>
      <Route />
      {/* <WebSocketBillPrinter/> */}
      <Toaster />
    </React.Fragment>
  );
}

export default App;
